import { dictionary as account_dictionary } from "./dashboard_account";
import { dictionary as cart_dictionary } from "./dashboard_cart";
import { dictionary as store_dictionary } from "./dashboard_store";
import { dictionary as products_dictionary } from "./dashboard_products";
import { dictionary as categories_dictionary } from "./dashboard_categories";
import { dictionary as notifications_dictionary } from "./dashboard_notifications";
import { dictionary as orders_dictionary } from "./dashboard_orders";
import { dictionary as share_dictionary } from "./dashboard_share";
import { dictionary as shared_dictionary } from "./shared";
import { dictionary as tutorial_dictionary } from "./dashboard_tutorial";
import { dictionary as login_dictionary } from "./login";
import { dictionary as landingpage_dictionary } from "./landingpage";
import { dictionary as order_dictionary } from "./menu_order";
import { dictionary as menu_dictionary } from "./menu";
import { dictionary as product_dictionary } from "./menu_product";
import { dictionary as table_dictionary } from "./dashboard_table";

const PAGES = {
  shared: shared_dictionary,
  dashboard_tutorial: tutorial_dictionary,
  dashboard_account: account_dictionary,
  dashboard_cart: cart_dictionary,
  dashboard_store: store_dictionary,
  dashboard_products: products_dictionary,
  dashboard_categories: categories_dictionary,
  dashboard_orders: orders_dictionary,
  dashboard_notifications: notifications_dictionary,
  dashboard_share: share_dictionary,
  dashboard_table: table_dictionary,
  login: login_dictionary,
  landingpage: landingpage_dictionary,
  menu_order: order_dictionary,
  menu: menu_dictionary,
  menu_product: product_dictionary,
} as const;

export const getTranslation = <
  Type extends keyof typeof PAGES,
  key extends keyof typeof PAGES[Type]
>(
  page: Type,
  key: key,
  lang: keyof typeof PAGES[Type][key]
) => PAGES[page][key][lang];
